var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHourglass = function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.333 12-2.5-3h14.5v.5l-2.5 3.5-3.5 1-2.5-.5-3.5-1.5Z",
    fill: "#FFE1CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.533 1c-.45 0-.883.18-1.202.502a1.723 1.723 0 0 0-.498 1.213v2.708c0 2.274.896 4.456 2.49 6.065A8.461 8.461 0 0 0 14.333 14a8.461 8.461 0 0 0 6.01-2.512 8.617 8.617 0 0 0 2.49-6.065V2.715c0-.454-.179-.89-.497-1.213A1.693 1.693 0 0 0 21.133 1h-13.6ZM7.533 27c-.45 0-.883-.18-1.202-.503a1.723 1.723 0 0 1-.498-1.212v-2.707c0-2.275.896-4.457 2.49-6.066A8.461 8.461 0 0 1 14.333 14c2.255 0 4.417.904 6.01 2.512a8.618 8.618 0 0 1 2.49 6.066v2.707c0 .454-.179.89-.497 1.212a1.692 1.692 0 0 1-1.203.503h-13.6ZM6.833 9h15",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.833 26c-1.47-2.619-4.278-5-7.5-5-3.222 0-6.029 2.381-7.5 5",
    fill: "#FFE1CF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.833 26c-1.47-2.619-4.278-5-7.5-5-3.222 0-6.029 2.381-7.5 5",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgHourglass;